export default __webpack_public_path__ + "static/media/FAC3.dc0882fa.jpg";